<script lang="ts">
import { onMount } from "svelte";
import { writable } from "svelte/store";
import { deleteOne, find, findResult, insertOne } from "../api";

import Loading from "../components/loading/Loading.svelte";
import Table from "../components/table/Table.svelte";

import { MediaServerUrl } from "ts-media-server-url";

const data         = writable(findResult<string[]>());
const isLoading    = writable(false);
const addIsLoading = writable(false);
const reIsUrl      = /^https?:\/\/media02\.ogonline\.nl\//i;

let url = "";

function parseUrl (url: string) {
	const isMSU = reIsUrl.test(url);
	let MSU: MediaServerUrl | undefined;
	let path   = "";
	let source = "";
	let error  = "";

	if (isMSU) {
		try {
			MSU    = new MediaServerUrl(url.replace(reIsUrl, "/"));
			path   = MSU.toString().replace(/\/[a-zA-Z0-9.=\-_]+$/, "");
			source = MSU.toImportUrl();


			if (
				MSU.domain !== "import"
				|| !MSU.userId
				|| !MSU.objectType
				|| !MSU.objectId
				|| !MSU.importType
				|| !MSU.file
			) {
				throw new Error("Could not parse url");
			}
		} catch (e) {
			error = e.toString();
		}
	}

	return {
		isMSU,
		MSU,
		path,
		source,
		error,
	};
}

async function addUrl ( ) {
	if (error || !url) {
		return false;
	}

	$addIsLoading = true;

	if (isMSU) {
		console.log("isMSU")
		await deleteOne(path);
		await insertOne("/blacklist", { url: source });
	} else {
		await insertOne("/blacklist", { url });
	}
	getData();

	url           = "";
	$addIsLoading = false;
}

async function deleteUrl (url: string) {
	if (confirm(`Are you sure you want to delete '${url}' from the blacklist?`)) {
		$isLoading = true;
		
		await deleteOne("/blacklist", { url });
		getData();
	}
}

$: ({ isMSU, MSU, path, source, error } = parseUrl(url));

async function getData ( ) {
	$isLoading = true;

	try {
		$data = await find(
			"/blacklist"
		);
	} catch (e) {
	}

	$isLoading = false;
}

onMount(getData);
</script>

<div class="blacklist">
	<div class="row bg-secondary">
		<div class="col d-flex flex-row align-items-center pt-3 pb-3">
			<h2 class="mb-0">Add URL to blacklist</h2>
		</div>
	</div>
	<form on:submit|preventDefault={addUrl} class="position-relative">
		<div class="form-group pt-3 mb-3">
			<label for="#">Media Server URL / External URL</label>
			<input type="text" class="form-control" bind:value={url}>
		</div>
	{#if url}
		{#if error}
			<div class="row">
				<div class="col">
					<div class="alert alert-danger">
						<p class="mb-0">
							<strong>Error:</strong> {error}
						</p>
					</div>
				</div>
			</div>
		{:else if isMSU}
			<div class="row">
				<div class="col">
					<div class="alert alert-info">
						<p class="mb-0">
							<strong>Note:</strong> This will add the URL <a href="{source}" target="_blank">{source}</a> to the blacklist and remove all files in <em>{path}</em>
						</p>
					</div>
					<button class="btn btn-primary mb-3" type="submit">Add URL to blacklist and remove cached files</button>
				</div>
			</div>
		{:else}
			<div class="row">
				<div class="col">
					<div class="alert alert-warning">
						<p class="mb-0">
							<strong>Warning:</strong> This will add the URL <a href="{url}" target="_blank">{url}</a> to the blacklist but <strong>will not</strong> remove any files from the server. Consider using the <em>media02.ogonline.nl</em> url instead.
						</p>
					</div>
					<button class="btn btn-primary mb-3" type="submit">Add URL to blacklist</button>
				</div>
			</div>
		{/if}
	{/if}
		<Loading class="bg-dark" isLoading={$addIsLoading} duration="{25}"><div class="loading-spinner"></div></Loading>
	</form>
	<div class="row bg-secondary">
		<div class="col d-flex flex-row align-items-center pt-3 pb-3">
			<button class="btn btn-secondary" on:click="{( ) => getData()}"><i class="fas fa-sync"></i></button>
			<h2 class="mb-0">Blacklist</h2>
		</div>
	</div>
	<div class="row position-relative">
		<Table data="{$data.result}" class="table table-dark table-fixed">
			<tr slot="thead">
				<th width="90%">
					URL
				</th>
				<th width="10%">
					Actions
				</th>
			</tr>
			<tr slot="tbody" let:item>
				<td>
					{item}
				</td>
				<td>
					<a class="text-danger" href="#delete" on:click|preventDefault="{( ) => { deleteUrl(item) }}"><strong><i class="fas fa-times"></i> Delete</strong></a>
				</td>
			</tr>
		</Table>
		<Loading class="bg-dark" isLoading={$isLoading} duration="{25}"><div class="loading-spinner"></div></Loading>
	</div>
</div>
